@if (project(); as p) {
  <pai-project-item-card [project]="p" />
}
